/* Role gates driven by the ACTIVE role lens (useRoles), so the UI shows one */
/* mode at a time. These reflect the *current mode*, not raw capabilities — a */
/* multi-role user in 'eleve' mode reads as neither admin nor teacher here. The */
/* AdminRoute redirect guard still checks the role_assignments table itself. */

import { useRoles } from './use-roles';

export function useIsAdmin(): boolean {
  const { activeRole } = useRoles();
  return activeRole === 'admin';
}

/** Teacher space is shown only in 'teacher' mode (admin mode has its own). */
export function useIsTeacher(): boolean {
  const { activeRole } = useRoles();
  return activeRole === 'teacher';
}
